export const D4_SET_AFFIXES = [
    "Applied Alchemy",
    "Arms of Arreat",
    "Art of the Bone Weaver",
    "Balazan's Bite",
    "Berserker's Crucible",
    "Bliss of the Multitude",
    "Bloodletter's Flow",
    "Breath of Frozen Sea",
    "Bul-Kathos' Pride",
    "Cain's Wild Lightning",
    "Cathan's Dauntless Faith",
    "Cathan's Iron Conviction",
    "Cathan's Righteous Will",
    "Dark Pact",
    "Flesh of Abbadon",
    "Fulcrum of Mefis",
    "Habacalva's Cauldron",
    "Heaven's Radiant Fire",
    "Horazon's Chains",
    "Kwatli's Grace",
    "Legacy of the Sightless",
    "Light's Epiphany",
    "Mastery",
    "Might of the Den Mother",
    "Nafain's Bestiary",
    "Nilfur's Narrow Eye",
    "Peace of the Black Shroud",
    "Practiced Technique",
    "Radament's Desecration",
    "Rathma's Waking Touch",
    "Rezoka's Rage",
    "Ritual of the Nameless",
    "Rush of the Red Wolf Moon",
    "Sescheron's Fury",
    "Shadow of Harash",
    "Slaughter",
    "Song of the Old Mountain",
    "Spellbound Steel",
    "Storm Shepherd's Call",
    "Survival",
    "Tal Rasha's Threefold Way",
    "Tiraj's Uncanny Insight",
    "Unlocks X_0 Charm Slots",
    "Way of the Blurring Blade",
    "Word of the Blood Binder",
    "Wumba's Embrace"
    ]
;
